import React, { useEffect, useRef, createElement } from 'react';
declare global {
  interface Window {
    hbspt?: {
      forms: {
        create: (config: Record<string, unknown>) => void;
      };
    };
  }
}
export function Contact() {
  const formContainerRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    const script = document.createElement('script');
    script.src = 'https://js-eu1.hsforms.net/forms/v2.js';
    script.charset = 'utf-8';
    script.addEventListener('load', () => {
      if (window.hbspt && formContainerRef.current) {
        window.hbspt.forms.create({
          region: 'eu1',
          portalId: '148205273',
          formId: '8aac18f6-1a5c-44dc-bf66-6bf01c3fe8d7',
          target: '#hs-form-container'
        });
      }
    });
    document.body.appendChild(script);
    return () => {
      if (document.body.contains(script)) {
        document.body.removeChild(script);
      }
    };
  }, []);
  return <section id="contact" className="relative" data-id="element-9">
      {/* Sharp lime accent divider */}
      <div className="relative" style={{
      background: 'var(--color-bg)'
    }} data-id="element-10">
        <div className="h-4" style={{
        background: 'var(--color-lime)'
      }} data-id="element-11" />
      </div>

      {/* White background area */}
      <div className="bg-white pt-16 md:pt-24 pb-24 md:pb-32" data-id="element-12">
        <div className="container mx-auto px-6 md:px-12 max-w-7xl" data-id="element-13">
          <div className="grid grid-cols-1 md:grid-cols-12 gap-12" data-id="element-14">
            <div className="md:col-span-3" data-id="element-15">
              <p className="text-xs md:text-sm font-mono uppercase tracking-[0.3em] text-zinc-500 sticky top-32" data-id="element-16">
                KONTAKT
              </p>
            </div>

            <div className="md:col-span-9" data-id="element-17">
              <div className="max-w-xl relative" data-id="element-18">
                {/* HubSpot Form — rendered inline via v2 API */}
                <div id="hs-form-container" ref={formContainerRef} className="hs-form-wrapper hs-form-wrapper--light" data-id="element-19" />

                {/* White block to cover HubSpot branding at the bottom */}
                <div className="relative z-10 -mt-20 h-20 pointer-events-none" style={{
                background: '#ffffff'
              }} aria-hidden="true" data-id="element-20" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}